import { WalletAction, WalletActionTile } from './wallet-actions.model';

/** Where each tile leads. */
export const WALLET_ACTION_ROUTES: Record<WalletAction, string> = {
	deposit: '/wallet/deposit',
	transfer: '/wallet/transfer',
	withdraw: '/wallet/withdraw',
	history: '/wallet/transfer-history'
};

/** The tiles in the handoff's order. */
export const WALLET_ACTIONS: readonly WalletActionTile[] = [
	{ key: 'deposit', label: 'واریز', icon: { kind: 'icon', name: 'settle', className: 'text-green-500' } },
	// The shared set has no wallet-transfer icon, so the handoff's artwork ships with the app.
	{ key: 'transfer', label: 'انتقال', icon: { kind: 'image', src: 'assets/images/wallet-transfer.svg' } },
	{ key: 'withdraw', label: 'برداشت', icon: { kind: 'icon', name: 'withdraw', className: 'text-red-500' } },
	{ key: 'history', label: 'تاریخچه', icon: { kind: 'icon', name: 'history', className: 'text-gray-800' } }
];
